import React from 'react';

export default {
  width: 33,
  height: 23,
  content: <path d="M0 .70459h33V3.4094H0zM0 10.1748h33v2.70482H0zM0 19.645h33v2.70482H0z" />
};
